import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    margin: {
      marginTop: 10,
    },
    emptyMessage: {
      paddingTop: 20,
      paddingBottom: 20,
      fontStyle: 'italic',
    },
    table: {
      borderCollapse: 'separate',
      borderSpacing: '0px 4px',
    },
    tablePagination: {
      height: 96,
      borderTop: 'unset',

      '& .MuiTablePagination-spacer': {
        flex: 'none',
      },
    },
    button: {
      width: 56,
      height: 56,
      borderRadius: 8,
      paddingRight: 16,
      paddingLeft: 16,
    },
  }),
);
